import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=aaef7348&"
import script from "./Database.vue?vue&type=script&lang=js&"
export * from "./Database.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaef7348')) {
      api.createRecord('aaef7348', component.options)
    } else {
      api.reload('aaef7348', component.options)
    }
    module.hot.accept("./Database.vue?vue&type=template&id=aaef7348&", function () {
      api.rerender('aaef7348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/Database.vue"
export default component.exports